import { c as _c } from "react/compiler-runtime";
import { useStore } from 'zustand';
import { useEffect, useRef } from 'react';
import { useLoadDemoData } from './use-load-demo-data';
import { useAppState, useAppStateActions } from '../store/use-app-state-store';
import { usePianoProfileState } from '../store/use-piano-profile-store';
import { useMeasuresStore, type MeasuresStore } from '../store/use-measure-store';
import { useShallow } from 'zustand/shallow';
import { useLogger } from '../use-logger';

/**
 * Loads the demonstration piano on a first visit, and only then.
 *
 * The application keeps one profile at a time, so this must never run over
 * someone's own instrument: a profile that has been named or measured is
 * theirs, whatever the flag says, and the demo is theirs to load from the
 * home page if they want it.
 */
export const useAutoloadDemoData = () => {
  const $ = _c(15);
  const {
    hasLoadedDemoData
  } = useAppState();
  const {
    updateSingleState
  } = useAppStateActions();
  const {
    loadDemoData
  } = useLoadDemoData();
  const {
    brand,
    isDemoProfile,
    model,
    serialNumber
  } = usePianoProfileState();
  const measures = useStore(useMeasuresStore(), useShallow(_temp));
  const logger = useLogger();
  const hasExecuted = useRef(false);
  let t0;
  if ($[0] !== brand || $[1] !== isDemoProfile || $[2] !== measures || $[3] !== model || $[4] !== serialNumber) {
    t0 = !isDemoProfile && (brand !== null || model !== null || serialNumber !== null || measures.some(_temp3));
    $[0] = brand;
    $[1] = isDemoProfile;
    $[2] = measures;
    $[3] = model;
    $[4] = serialNumber;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const hasOwnProfile = t0;
  let t1;
  let t2;
  if ($[6] !== hasLoadedDemoData || $[7] !== hasOwnProfile || $[8] !== loadDemoData || $[9] !== logger || $[10] !== updateSingleState) {
    t1 = () => {
      if (!hasLoadedDemoData && !hasOwnProfile && !hasExecuted.current) {
        hasExecuted.current = true;
        ;
        try {
          loadDemoData();
          updateSingleState("hasLoadedDemoData", true);
        } catch (t3) {
          const error = t3;
          logger.warn("Failed to load demo data", error);
        }
      }
    };
    t2 = [hasLoadedDemoData, hasOwnProfile, loadDemoData, logger, updateSingleState];
    $[6] = hasLoadedDemoData;
    $[7] = hasOwnProfile;
    $[8] = loadDemoData;
    $[9] = logger;
    $[10] = updateSingleState;
    $[11] = t1;
    $[12] = t2;
  } else {
    t1 = $[11];
    t2 = $[12];
  }
  useEffect(t1, t2);
  let t3;
  if ($[13] !== hasLoadedDemoData) {
    t3 = {
      hasLoadedDemoData
    };
    $[13] = hasLoadedDemoData;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
function _temp(state) {
  return state.keys;
}
function _temp2(value) {
  return value !== null;
}
function _temp3(key) {
  return Object.values(key).some(_temp2);
}